import { Ionicons } from "@expo/vector-icons";
import { Linking, Modal, Platform, StyleSheet, Text, View } from "react-native";
import { BlurView } from "expo-blur";
import { useCSSVariable } from "uniwind";

import { Button } from "@/shared/components/ui/button";

const STORE_URLS = {
  ios: "https://apps.apple.com/app/id/6764414807",
  android: "https://play.google.com/store/apps/details?id=com.lezz.app",
};

function openStore() {
  const url = Platform.OS === "ios" ? STORE_URLS.ios : STORE_URLS.android;
  Linking.openURL(url);
}

export function UpdateModal({ visible }: { visible: boolean }) {
  const [brandColor] = useCSSVariable(["--color-brand"]) as [string];

  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      statusBarTranslucent
    >
      <BlurView intensity={100} tint="dark" style={StyleSheet.absoluteFill}>
        <View className="flex-1 items-center justify-center p-6">
          <View className="bg-popover border-border/30 w-full max-w-sm rounded-2xl border p-6">
            <View className="mb-4 items-center">
              <Ionicons
                name="cloud-download-outline"
                size={56}
                color={brandColor}
              />
            </View>

            <Text className="font-display text-foreground mb-2 text-center text-2xl font-semibold">
              Atualização necessária
            </Text>

            <Text className="text-muted-foreground mb-6 text-center text-base">
              Uma nova versão do Lezz está disponível. Atualize para continuar
              usando o app.
            </Text>

            <Button onPress={openStore} accessibilityLabel="Atualizar agora">
              Atualizar agora
            </Button>
          </View>
        </View>
      </BlurView>
    </Modal>
  );
}
